import React, { useEffect, useState } from "react";
import { View, FlatList } from "react-native";

import { Tag, Separator } from "components";

import { sizes, strings } from "assets/constants";
import { obj } from "utils";
import css from "styles";

export default function SelectedFiltersView(props: {
  filters: any;
  onChange?: (filters: any) => void;
  filterItems: Array<{ key: string; title: string; value: any }>;
}) {
  const { filters, onChange, filterItems } = props;

  const [filtersState, setFilterState] = useState(filters);

  useEffect(() => {
    setFilterState(filters);
  }, [filters]);

  const _onUpdate = (newVal: any) => {
    const newFilters = { ...filtersState, ...newVal };
    onChange && onChange(newFilters);
  };

  const _renderItem = () => {
    return (
      <>
        {filterItems.map((filter, key) => {
          if (!filters?.[filter.key]) {
            return <React.Fragment key={String(key)} />;
          }

          return (
            <React.Fragment key={String(key)}>
              <Tag
                onPress={() => _onUpdate({ [filter.key]: undefined })}
                title={strings[filter.title]}
                value={
                  obj.getItemInDepth(filters, filter.value.split(".")) as string
                }
              />
              <Separator axis="y" space={2} />
            </React.Fragment>
          );
        })}
      </>
    );
  };

  if (!filtersState || obj.isEmpty(filtersState)) {
    return <></>;
  }

  return (
    <View style={{ height: sizes.tagHeight, ...css.justifyEnd }}>
      <FlatList
        keyExtractor={(_, key) => String(key)}
        inverted
        horizontal
        contentContainerStyle={{ ...css.paddingH, alignItems: "center" }}
        showsHorizontalScrollIndicator={false}
        data={["_"]}
        renderItem={_renderItem}
      />
    </View>
  );
}
